<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />

    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="process"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import PublicPortalServices from '@/services/api/publicPortal.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  name: 'SatisfactionQuestionnaire',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        collections: {
          academicYears: [],
          periods: [],
          areas: [],
        },
        filters: {
          academicYear: null,
          period: null,
          area: null,
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Cuestionarios de Satisfacción',
        icon: 'fas fa-file-invoice',
        routes: ['Informes', 'Cuestionarios de Satisfacción'],
      }
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año.',
          validations: 'required',
          class: 'col-md-4',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
        {
          name: 'period',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Periodo',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un período.',
          validations: 'required',
          class: 'col-md-4',
          clearable: false,
          options: this.model.search.collections.periods,
          value: this.model.search.filters.period,
        },
        {
          name: 'area',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Área',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un área.',
          validations: 'required',
          class: 'col-md-4',
          clearable: false,
          options: this.model.search.collections.areas,
          value: this.model.search.filters.area,
        },
      ]
    },
  },
  async mounted() {
    const { data } = await PublicPortalServices.initFiltersSatisfactionQuestionnaire()
    this.model.search.collections.academicYears = data.academicYearList
    this.model.search.collections.periods = data.periodList
    this.model.search.collections.areas = data.areaList
  },
  methods: {
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      await ReportServices.getReport('satisfactionquestionnaire', {
        academicYearId: this.model.search.filters.academicYear?.id,
        periodNumber: this.model.search.filters.period?.id,
        areaId: this.model.search.filters.area?.id,
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>
